<template>
    <header class="header-global header_triplea" >
        <div class="triplea-container">
            <nav class="navbar navbar-expand-lg">
                <a class="navbar-brand" href="/triplea">
                    <img class="header-logo" src="@/assets/img/triplea/header-logo.png" alt="Apolar Triple A">
                </a>
                <div class="collapse navbar-collapse" id="tripleanavbar">
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item active">
                            <a class="header-nav-link" href="/triplea/busca?residencial">
                                Comprar
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="header-nav-link" href="/triplea/busca?mensal">
                                Alugar
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="header-nav-link" href="https://anuncie.apolar.com.br/">
                                Anunciar Imóveis
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="header-nav-button" href="https://franqueado.apolar.com.br/">
                                Seja um Franqueado
                            </a>
                        </li>
                        <li class="nav-item">
                            <button class="header-currency-button" title="Indisponível">
                                <img src="@/assets/img/triplea/flags/br.svg" />
                                PT-BR (R$)
                            </button>
                        </li>
                    </ul>
                </div>
                <HeaderMenuDropdown />
            </nav>
        </div>
    </header>
</template>
<script>
import Vue from 'vue'
import 'vue-select/dist/vue-select.css';
import "@/assets/scss/custom/triplea/components/_header.scss";
import HeaderMenuDropdown from '../views/components/apolar/triplea/HeaderMenuDropdown.vue';

export default {
  components: {
    HeaderMenuDropdown,
  },
  computed: {
  },
  data() {
    return {

    }
  },
  methods: {
  },
  mounted() {
  }
};
</script>